export interface MemberProfile {
  slug: string
  name: string
  role: string
  roleEs?: string
  city: string
  state: string
  company?: string
  industry: string
  industryEs?: string
  badge: string
  badgeEs: string
  photo: string
  bio: string
  bioEs: string
  socialLinks?: {
    platform: 'linkedin' | 'instagram' | 'twitter' | 'website'
    url: string
    label: string
  }[]
}

export const MEMBER_PROFILES: MemberProfile[] = [
  {
    slug: 'jay',
    name: 'Jay Miranda',
    role: 'President & CEO',
    roleEs: 'Presidente y CEO',
    city: 'Washington',
    state: 'D.C.',
    company: 'Honduran-American Association',
    industry: 'Nonprofit & Community Development',
    industryEs: 'Desarrollo Comunitario y Sin Fines de Lucro',
    badge: 'MEMBER',
    badgeEs: 'MIEMBRO',
    photo:
      'https://cdn.magicpatterns.com/uploads/1BjECftzUECa1wsk2Hnhxn/154112125_z2tgzajma9-GCIGray.jpg',
    bio: `Jay Miranda is a Honduran-born, San Francisco-raised community builder, philanthropist, and advocate for equity. A first-generation college graduate, he holds a degree in Public Administration from National University and is completing his Master's in International Migration and Refugee Studies at Georgetown University's School of Foreign Service.

For over 20 years, Jay has championed underserved communities through strategic leadership, nonprofit development, and cross-sector partnerships. His professional journey includes securing multimillion-dollar international deals as a Business Development Manager for Latin America and leading initiatives in donor engagement, volunteer mobilization, and executive coaching.

Jay is the co-founder of the Honduran American Association, a national platform that connects, empowers, and celebrates the over 1.8 million members of the Honduran diaspora in the U.S. A passionate speaker and lifelong change maker, he channels his voice to uplift others and drive social impact across borders.`,
    bioEs: `Jay Miranda es un constructor comunitario, filántropo y defensor de la equidad nacido en Honduras y criado en San Francisco. Como graduado universitario de primera generación, tiene una licenciatura en Administración Pública de National University y está completando su Maestría en Migración Internacional y Estudios de Refugiados en la Escuela de Servicio Exterior de la Universidad de Georgetown.

Durante más de 20 años, Jay ha defendido a comunidades desatendidas a través de liderazgo estratégico, desarrollo de organizaciones sin fines de lucro y asociaciones intersectoriales. Su trayectoria profesional incluye asegurar acuerdos internacionales multimillonarios como Gerente de Desarrollo Comercial para América Latina y liderar iniciativas en participación de donantes, movilización de voluntarios y coaching ejecutivo.

Jay es cofundador de la Asociación Hondureño-Americana, una plataforma nacional que conecta, empodera y celebra a los más de 1.8 millones de miembros de la diáspora hondureña en los EE. UU. Un orador apasionado y un agente de cambio de por vida, canaliza su voz para elevar a otros e impulsar el impacto social a través de las fronteras.`,
    socialLinks: [
      {
        platform: 'linkedin',
        url: 'https://www.linkedin.com/in/jay-miranda',
        label: 'LinkedIn',
      },
    ],
  },
  {
    slug: 'sindy',
    name: 'Sindy Benavides',
    role: 'Board Chair',
    roleEs: 'Presidenta de la Junta',
    city: 'Washington',
    state: 'D.C.',
    company: 'Honduran-American Association',
    industry: 'Civic Leadership & Public Service',
    industryEs: 'Liderazgo Cívico y Servicio Público',
    badge: 'MEMBER',
    badgeEs: 'MIEMBRO',
    photo:
      'https://cdn.magicpatterns.com/uploads/b1GB8Z9aEvoE58p9BdX4qx/Sindy_Benavides.jpg',
    bio: `Sindy Benavides is a Honduran-American civic leader and the Board Chair of the Honduran-American Association. She has dedicated her career to public service, community organizing, and advocating for the rights and advancement of the Latino community in the United States.

With extensive experience in national leadership roles, Sindy brings strategic vision and a deep commitment to empowering the Honduran diaspora. Her work focuses on building civic engagement, expanding economic opportunities, and ensuring that Honduran-American voices are represented at all levels of decision-making.`,
    bioEs: `Sindy Benavides es una líder cívica hondureño-americana y Presidenta de la Junta de la Asociación Hondureño-Americana. Ha dedicado su carrera al servicio público, la organización comunitaria y la defensa de los derechos y el avance de la comunidad latina en los Estados Unidos.

Con amplia experiencia en roles de liderazgo nacional, Sindy aporta una visión estratégica y un profundo compromiso para empoderar a la diáspora hondureña. Su trabajo se centra en fomentar la participación cívica, ampliar las oportunidades económicas y garantizar que las voces hondureño-americanas estén representadas en todos los niveles de toma de decisiones.`,
    socialLinks: [
      {
        platform: 'linkedin',
        url: 'https://www.linkedin.com/in/sindybenavides',
        label: 'LinkedIn',
      },
    ],
  },
]
